import { MantineThemeOther } from '@mantine/core';

export const THEME_OTHER: MantineThemeOther = {
  // @todo: remove `primaryColor` in favor of `theme.fn.primaryColor()`
  primaryColor: '#2979FF',
  openedSidebarWidth: 300,
  closedSidebarWidth: 76,
  navbarHeight: 62,
};
